// F5 — ссылка-приглашение для контрибьютора.
//
// Зачем: раньше админ создавал человека и диктовал ему пароль вслух или в
// переписке. Ссылка живёт 7 дней, открывается на телефоне человека и сразу
// заводит сессию — ни пароля, ни опечаток.
import { useEffect, useState } from 'preact/hooks';
import { api } from '../api';
import type { T } from '../i18n';

export function InviteModal({
  t,
  contributorId,
  name,
  onClose,
}: {
  t: T;
  contributorId: string;
  name: string;
  onClose: () => void;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api
      .invite(contributorId)
      .then((r) => setUrl(r.url))
      .catch(() => setError(true));
  }, [contributorId]);

  const copy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Буфер недоступен (не-HTTPS, старый браузер) — поле ниже выделяемо
      // руками, поэтому провал копирования не тупик.
      setCopied(false);
    }
  };

  return (
    <dialog open class="wb-card">
      <h3>{t('inv.title', { name })}</h3>
      {error ? (
        <div class="strip bad">{t('inv.failed')}</div>
      ) : !url ? (
        <p class="muted">{t('inv.creating')}</p>
      ) : (
        <>
          <p class="muted">
            {t('inv.note')}
          </p>
          {/* readonly-инпут, а не просто текст: с него ссылка выделяется и
              копируется руками, когда буфер обмена недоступен. */}
          <input class="invite-url" readOnly value={url} onClick={(e) => (e.target as HTMLInputElement).select()} />
          <div class="row">
            <button type="button" class="btn-primary" onClick={() => void copy()}>
              {copied ? t('inv.copied') : t('inv.copy')}
            </button>
            <button type="button" class="btn-ghost" onClick={onClose}>
              {t('inv.close')}
            </button>
          </div>
        </>
      )}
      {(error || !url) && (
        <div class="row">
          <button type="button" class="btn-ghost" onClick={onClose}>
            {t('inv.close')}
          </button>
        </div>
      )}
    </dialog>
  );
}
